import React from "react";
import FinancialReportPage from "../Reports/FinancialReportPage";

const ReportReceivablePage = () => <FinancialReportPage type="receivables" />;

export default ReportReceivablePage;
